import { Box } from '@chakra-ui/react';
import { useTableCellContext } from '../context';

const TableCellCustomChildren = () => {
  const context = useTableCellContext();

  if (context.cellType === 'customChildren') {
    const { childs, dataTestId, justifyContent, ...props } = context;

    return (
      <Box
        display='flex'
        alignItems='center'
        justifyContent={justifyContent || 'flex-start'}
        height='max-content'
        width='max-content'
        minHeight='max-content'
        borderRadius={0}
        border='none'
        borderWidth={0}
        padding={0}
        margin={0}
        data-testid={dataTestId || 'cjtable-cell-custom-id'}
        {...props}
      >
        {childs}
      </Box>
    );
  }
  return null;
};

export default TableCellCustomChildren;
